module.exports = __webpack_public_path__ + "img/1.4d056f37.png";